import React, { FC } from 'react'
import { FacetListChips } from 'components/SA/Facets'
import { USER_ARTWORKS_NEXT_APP_ROUTE } from '../../helpers/constants'
import URLConnector, { ConnectorProps as URLConnectorProps } from '../../connectors/Url'

const USER_ARTWORKS_FILTERS_WHITE_LIST = [
  'category',
  'original_status',
  'price',
  'size',
  'orientation',
]

const FiltersChips: FC<URLConnectorProps> = ({ urlPath }) => {
  return (
    <FacetListChips
      baseUrl={urlPath}
      nextAppRoute={USER_ARTWORKS_NEXT_APP_ROUTE}
      filtersWhiteList={USER_ARTWORKS_FILTERS_WHITE_LIST}
    />
  )
}

export default URLConnector(FiltersChips)
